import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { CacheService } from "./cache.service";

@Injectable({
  providedIn: "root",
})
export class CacheInterceptor implements HttpInterceptor {
  constructor(private _cache: CacheService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.method === "GET") {
      const cachedResponse = this._cache.get(request);
      if (cachedResponse)
        return cachedResponse;
      let req = next.handle(request).pipe(shareReplay(1));
      this._cache.put(request, req);
      return req;
    } else if (
      request.method === "POST" ||
      request.method === "PUT" ||
      request.method === "PATCH" ||
      request.method === "DELETE"
    ) {
      this._cache.invalidate(request);
    }
    return next.handle(request);
  }
}
